module.exports = __webpack_public_path__ + "static/media/Edit.e71c39b8.png";